import React from "react";

const Notifications = () => {
  return <p>edit notifications</p>;
};

export default Notifications;
